/// <amd-module name="Wit/MentionsAutocomplete/Providers/IWorkItemProviderItem" />
export interface IWorkItemProviderItem {
    id: number;
    title: string;
    projectName: string;
    workItemType: string;
    state: string;
}
